const LOGIN_FAILURE_MESSAGES = {
  server_network: {
    type: "server_network",
    title: "연결 오류",
    body: "로그인 요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요."
  },
  account_expired: {
    type: "account_expired",
    title: "계정 만료",
    body: "계정이 만료되었습니다. 관리자에게 갱신을 문의하세요."
  },
  invalid_credentials: {
    type: "invalid_credentials",
    title: "로그인 실패",
    body: "아이디 또는 비밀번호가 올바르지 않습니다. 다시 확인해 주세요."
  }
};

export function resolveLoginFailure(error) {
  const response = error && error.response;

  if (!response || response.status >= 500) {
    return LOGIN_FAILURE_MESSAGES.server_network;
  }

  const data = response.data || {};
  const message = String(data.message || "");
  if (response.status === 400 && message.toLowerCase().includes("expired")) {
    return LOGIN_FAILURE_MESSAGES.account_expired;
  }

  return LOGIN_FAILURE_MESSAGES.invalid_credentials;
}
